import { render, staticRenderFns } from "./ViewportDetailsPanel.vue?vue&type=template&id=38138d32&scoped=true"
import script from "./ViewportDetailsPanel.vue?vue&type=script&lang=js"
export * from "./ViewportDetailsPanel.vue?vue&type=script&lang=js"
import style0 from "./ViewportDetailsPanel.vue?vue&type=style&index=0&id=38138d32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38138d32",
  null
  
)

export default component.exports